import './polyfills.js'
import FormValidated from './FormValidated'
export default FormValidated


// WEBPACK FOOTER //
// ./src/index.js